import { Number, Record, Static, String } from "runtypes";

export const DirectorRequestRuntype = Record({
  email: String,
  schoolId: Number,
  firstName:String,
  lastName:String
});

export interface IDirectorRequest
  extends Static<typeof DirectorRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/services/IDirectorRequest.ts